import { FilterKey } from '@studyportals/search-filters';
import { FilterSelectionState } from '@/filters/selection/FilterSelectionState';
import { Degree } from '@/models/Degree';
import { ISeoMetaDataInfo } from '../ISeoMetaDataInfo';
import { SeoMetaDataHandlerDefaultSort } from '../SeoMetaDataHandlerDefaultSort';

export class Discipline extends SeoMetaDataHandlerDefaultSort {
	protected async canHandleWithDefaultSorting(filterSelectionState: FilterSelectionState): Promise<boolean> {
		return (
			(await this.singleSelectionFor(FilterKey.DISCIPLINES, filterSelectionState)) &&
			this.selectionOnlyFor([FilterKey.DISCIPLINES], filterSelectionState)
		);
	}

	protected async selfHandle(degree: Degree, filterSelectionState: FilterSelectionState): Promise<ISeoMetaDataInfo> {
		const discipline = this.getFilterOptionNameBy(FilterKey.DISCIPLINES, filterSelectionState);
		const portalName = degree.toPortalName();

		const seoInfo = {
			title: `List of universities to study ${discipline} | ${portalName}`,

			description:
				`Check out our complete list of universities for ${discipline}. ` +
				`Browse by country or state to find your best option to study ${discipline}.`,
		};

		return Promise.resolve(seoInfo);
	}
}
